import { render, staticRenderFns } from "./Optix.vue?vue&type=template&id=7216be34&"
import script from "./Optix.vue?vue&type=script&lang=js&"
export * from "./Optix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports